"use client";

import { useState, useEffect } from 'react';

/**
 * 响应式断点检测 Hook
 * @param query CSS 媒体查询字符串，如 "(min-width: 1024px)"
 * @returns 是否匹配该媒体查询
 */
export function useMediaQuery(query: string): boolean {
  // 使用函数初始化，在客户端立即检测
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    // 创建媒体查询对象
    const media = window.matchMedia(query);

    // 确保状态与实际值同步
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    // 监听变化
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);
    media.addEventListener('change', listener);

    // 清理
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
}

/**
 * 预设断点 Hook
 */
export function useIsMobile(): boolean {
  return !useMediaQuery('(min-width: 1024px)');
}

export function useIsTablet(): boolean {
  return useMediaQuery('(min-width: 768px)') && !useMediaQuery('(min-width: 1024px)');
}

export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)');
}
